import React from "react";
import { useState } from "react";

const NavBarContext = React.createContext({
  isShown: false,
  show: () => {},
  hide: () => {},
});

export const NavBarProvider = (props) => {
  const [isShown, setIsShown] = useState(true);

  const showHandler = () => {
    setIsShown(true);
  };

  const hideHandler = () => {
    setIsShown(false);
  };

  return (
    <NavBarContext.Provider
      value={{ isShown: isShown, show: showHandler, hide: hideHandler }}
    >
      {props.children}
    </NavBarContext.Provider>
  );
};

export default NavBarContext;
